import { getBookingTotalNewCustomer } from "@/api/report";
import { accountInfoState, salonActiveState } from "@/components/state";
import { formatDateTime } from "@/utils";
import { Dayjs } from "dayjs";
import { useRecoilState } from "recoil";

export function useQueriesBookingTotalNewCustomer(dateRange: [Dayjs, Dayjs]) {
    const [salonActive] = useRecoilState(salonActiveState);
    const [currentAccount] = useRecoilState(accountInfoState);

    if(salonActive) {
        const queriesBookingTotalNewCustomerSalonActive = salonActive?.salonBranches?.map((branch) => ({
            requestMeta: getBookingTotalNewCustomer,
            requestData: {
                query: {
                    startDate: formatDateTime(dateRange[0]),
                    endDate: formatDateTime(dateRange[1]),
                    salonId: salonActive.id,
                    salonBranchId: branch.id
                }
            }
        }))

        return queriesBookingTotalNewCustomerSalonActive ?? [];
    }

    const queriesBookingTotalNewCustomerAllSalons = currentAccount?.salons?.map((salon) => {
        return {
            requestMeta: getBookingTotalNewCustomer,
            requestData: {
                query: {
                    startDate: formatDateTime(dateRange[0]),
                    endDate: formatDateTime(dateRange[1]),
                    salonId: salon.id
                }
            }
        }
    }).flat() ?? [];

    return queriesBookingTotalNewCustomerAllSalons;
}
